import { useHudPanels, useInputBindingPress } from '@sorrem-client/ui/hooks';
import { useCallback } from 'react';

export interface RunHudPanels {
    isMapOpen: boolean;
    setMapOpen: (open: boolean) => void;
    isCommissionOpen: boolean;
    setCommissionOpen: (open: boolean) => void;
}

/** The run HUD's map and commission panels, open or closed by the account's HUD settings and toggled by their bindings. */
export function useRunHudPanels(): RunHudPanels {
    const { panels, setPanelOpen } = useHudPanels();
    const setMapOpen = useCallback((open: boolean): void => setPanelOpen('map', open), [setPanelOpen]);
    const setCommissionOpen = useCallback((open: boolean): void => setPanelOpen('commission', open), [setPanelOpen]);

    useInputBindingPress('toggle-commission', () => setCommissionOpen(!panels.commission));
    useInputBindingPress('toggle-map', () => setMapOpen(!panels.map));

    return { isMapOpen: panels.map, setMapOpen, isCommissionOpen: panels.commission, setCommissionOpen };
}
